namespace('compass.hotel');

compass.requireLib('compass.util.format');
compass.requireLib('compass.util.parse');

compass.hotel.AffiliateAvailableRoomListWidget = compass.defineWidget(function AffiliateAvailableRoomListWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;
	var _settings = options;
	var _currentSortMethod = 'recommended';
	var _sortWasChanged = false;
	var _varianceThreshold = 0.04;
	var _sortUidCounter = 0;
	var _activeFilters = { bedType: [], cancellation: [], payment: [], promotions: [] };
	var _shortDate = compass.util.dateFormatter('mmm dd');
	var _fullDate = compass.util.dateFormatter('mmmm dd, yyyy');

	// Filter extraction helpers
	function _getBedType(room) {
		if (!room.bed_groups) return '';
		var bedGroupIds = Object.keys(room.bed_groups);
		for (var i = 0; i < bedGroupIds.length; i++) {
			var group = room.bed_groups[bedGroupIds[i]];
			if (group.configuration) {
				for (var j = 0; j < group.configuration.length; j++) {
					var size = group.configuration[j].size || '';
					if (size) return size;
				}
			}
		}
		return '';
	}

	function _getCancellationType(room) {
		if (room.refundable !== true) {
			return 'Non-refundable';
		}
		if (room.cancel_penalties !== undefined) {
			var checkInDate = compass.util.parse.ISODateParser(_settings.searchCriteria.arrive);
			for (var cancelIndex = 0; cancelIndex < room.cancel_penalties.length; cancelIndex++) {
				var penaltyStartDate = new Date(room.cancel_penalties[cancelIndex].start);
				if (penaltyStartDate <= checkInDate) {
					return 'Partially refundable';
				}
			}
		}
		return 'Fully refundable';
	}

	function _getPaymentType(room) {
		if (room.merchant_of_record === 'expedia' || (room.merchant_of_record === 'property' && room.refundable === false)) {
			return 'Pay Now';
		}
		if (room.deposit_required === true || room.deposits !== undefined) {
			return 'Deposit Required';
		}
		return 'Pay Later';
	}

	function _getPromotions(room) {
		var promos = [];
		if (room.amenities) {
			for (var key in room.amenities) {
				if (room.amenities[key] && room.amenities[key].name) {
					promos.push(room.amenities[key].name);
				}
			}
		}
		if (room.promotions && room.promotions.deal && room.promotions.deal.description) {
			promos.push(room.promotions.deal.description);
		}
		return promos;
	}

	function _discoverFilterOptions(rooms) {
		var options = { bedType: {}, cancellation: {}, payment: {}, promotions: {} };
		for (var i = 0; i < rooms.length; i++) {
			var bed = _getBedType(rooms[i]);
			if (bed) options.bedType[bed] = true;

			var cancel = _getCancellationType(rooms[i]);
			if (cancel) options.cancellation[cancel] = true;

			var pay = _getPaymentType(rooms[i]);
			if (pay) options.payment[pay] = true;

			var promos = _getPromotions(rooms[i]);
			for (var j = 0; j < promos.length; j++) {
				options.promotions[promos[j]] = true;
			}
		}
		return {
			bedType: Object.keys(options.bedType).sort(),
			cancellation: Object.keys(options.cancellation).sort(),
			payment: Object.keys(options.payment).sort(),
			promotions: Object.keys(options.promotions).sort()
		};
	}

	function _applyFilters(rooms) {
		var categories = Object.keys(_activeFilters);
		var hasActive = false;
		for (var c = 0; c < categories.length; c++) {
			if (_activeFilters[categories[c]].length > 0) {
				hasActive = true;
				break;
			}
		}
		if (!hasActive) return rooms;

		return _.filter(rooms, function(room) {
			// AND across categories
			if (_activeFilters.bedType.length > 0) {
				var bed = _getBedType(room);
				if (_activeFilters.bedType.indexOf(bed) === -1) return false;
			}
			if (_activeFilters.cancellation.length > 0) {
				var cancel = _getCancellationType(room);
				if (_activeFilters.cancellation.indexOf(cancel) === -1) return false;
			}
			if (_activeFilters.payment.length > 0) {
				var pay = _getPaymentType(room);
				if (_activeFilters.payment.indexOf(pay) === -1) return false;
			}
			if (_activeFilters.promotions.length > 0) {
				var promos = _getPromotions(room);
				// OR within promotions: room must have at least one matching promo
				var hasMatch = false;
				for (var p = 0; p < promos.length; p++) {
					if (_activeFilters.promotions.indexOf(promos[p]) !== -1) {
						hasMatch = true;
						break;
					}
				}
				if (!hasMatch) return false;
			}
			return true;
		});
	}

	// Assign unique sort IDs to rooms for comparison
	function _assignSortUids() {
		var rooms_list = _settings.epsAvail && _settings.epsAvail.rooms;
		if (rooms_list) {
			for (var i = 0; i < rooms_list.length; i++) {
				if (rooms_list[i].sort_uid === undefined) {
					rooms_list[i].sort_uid = ++_sortUidCounter;
				}
			}
		}
	}

	// Initialize sort UIDs on widget creation
	_assignSortUids();

	function _formatShortDate(label, dateStr) {
		var date = compass.util.parse.ISODateParser(dateStr);
		return d.span(label,
			d.abbr({ title : _fullDate(date) }, _shortDate(date))
		);
	}

	function _handleSelectButtonClosure(roomData, isTopPick){
		var roomDataClosure = roomData;
		var isTopPickClosure = isTopPick;
		return function(clickevt){
			if (_currentSortMethod === 'recommended') {
				if (isTopPickClosure) {
					compass.GA.trackEvent('EPS', 'priority_rate_selected', roomDataClosure.roomName);
				} else if (_isPriorityRate(roomDataClosure)) {
					compass.GA.trackEvent('EPS', 'non_priority_od_rate_selected', roomDataClosure.roomName);
				} else {
					compass.GA.trackEvent('EPS', 'standard_rate_selected', roomDataClosure.roomName);
				}
				if (!_sortWasChanged) {
					compass.GA.trackEvent('EPS', 'recommended_kept', roomDataClosure.roomName);
				}
			}
			me.trigger('AffiliateAvailableRoomListWidget.roomSelected', { roomdata : roomDataClosure });
		};
	}

	function _handleViewRoomInfoClick(roomData) {
		var roomDataClosure = roomData;
		return function(clickevt) {
			me.trigger('AffiliateAvailableRoomListWidget.viewRoomInfoClicked', { roomdata : roomDataClosure });
		};
	}

	function _sortByLowestPrice(rooms) {
		return _.chain(rooms).sortBy(function(room) {
			return room.merchant_of_record;
		}).sortBy(function(room) {
			return room.roomName;
		}).sortBy(function(room) {
			return room.avgRate + room.fees;
		}).value();
	}

	// Shared helper functions for room sorting and filtering
	function _isPriorityRate(room) {
		return room.sale_scenario && room.sale_scenario.distribution === true;
	}

	function _getRate(room) {
		return room.avgRate + room.fees;
	}

	function _getBedCount(room) {
		if (!room.bed_groups) return 0;
		var bedGroupIds = Object.keys(room.bed_groups);
		if (bedGroupIds.length === 0) return 0;
		var firstGroup = room.bed_groups[bedGroupIds[0]];
		if (!firstGroup.configuration) return 0;
		var count = 0;
		for (var i = 0; i < firstGroup.configuration.length; i++) {
			count += firstGroup.configuration[i].quantity || 0;
		}
		return count;
	}

	function _hasKingBed(room) {
		if (!room.bed_groups) return false;
		var bedGroupIds = Object.keys(room.bed_groups);
		for (var i = 0; i < bedGroupIds.length; i++) {
			var group = room.bed_groups[bedGroupIds[i]];
			if (group.configuration) {
				for (var j = 0; j < group.configuration.length; j++) {
					var config = group.configuration[j];
					var type = (config.type || '').toLowerCase();
					var size = (config.size || '').toLowerCase();
					if (type.indexOf('king') !== -1 || size.indexOf('king') !== -1) {
						return true;
					}
				}
			}
		}
		return false;
	}

	function _sortByRecommended(rooms) {
		// Secondary sort: rate, then roomName, then merchant_of_record (matches _sortByLowestPrice)
		function compareSecondary(a, b) {
			var aRate = _getRate(a);
			var bRate = _getRate(b);

			if (aRate !== bRate) {
				return aRate - bRate;
			}

			// Rates are equal, compare by roomName
			if (a.roomName !== b.roomName) {
				return a.roomName < b.roomName ? -1 : 1;
			}

			// roomNames are equal, compare by merchant_of_record
			if (a.merchant_of_record !== b.merchant_of_record) {
				return a.merchant_of_record < b.merchant_of_record ? -1 : 1;
			}

			return 0;
		}

		function compareRecommended(a, b) {
			var aRate = _getRate(a);
			var bRate = _getRate(b);

			var aIsPriority = _isPriorityRate(a);
			var bIsPriority = _isPriorityRate(b);

			// If both have same priority status, use secondary sort
			if (aIsPriority === bIsPriority) {
				return compareSecondary(a, b);
			}

			// a has priority rate, b does not
			if (aIsPriority && !bIsPriority) {
				if (aRate <= bRate) {
					return -1; // pick a
				}
				// aRate > bRate
				if (bRate > 0 && (aRate - bRate) / bRate <= _varianceThreshold) {
					return -1; // pick a (within threshold)
				}
				return 1; // pick b (a is too expensive)
			}

			// b has priority rate, a does not
			if (bIsPriority && !aIsPriority) {
				if (bRate <= aRate) {
					return 1; // pick b
				}
				// bRate > aRate
				if (aRate > 0 && (bRate - aRate) / aRate <= _varianceThreshold) {
					return 1; // pick b (within threshold)
				}
				return -1; // pick a (b is too expensive)
			}

			// Fallback to secondary sort
			return compareSecondary(a, b);
		}

		// Separate priority rate rooms and get the 3 lowest-priced ones
		var priorityRooms = [];
		var otherRooms = [];
		for (var i = 0; i < rooms.length; i++) {
			if (_isPriorityRate(rooms[i])) {
				priorityRooms.push(rooms[i]);
			} else {
				otherRooms.push(rooms[i]);
			}
		}

		// Sort priority rate rooms by rate (lowest first), then prefer King over Queen for same rate and bed count
		// TODO: This is MVP, future iteration should have more robust bed-type prioritization
		priorityRooms.sort(function(a, b) {
			var rateDiff = _getRate(a) - _getRate(b);
			if (rateDiff !== 0) return rateDiff;

			// Same rate - check bed count
			var bedCountA = _getBedCount(a);
			var bedCountB = _getBedCount(b);
			if (bedCountA !== bedCountB) return 0; // Different bed counts, no preference

			// Same rate and bed count - prefer King over Queen
			var aHasKing = _hasKingBed(a);
			var bHasKing = _hasKingBed(b);
			if (aHasKing && !bHasKing) return -1;
			if (bHasKing && !aHasKing) return 1;

			return 0;
		});

		// Take top 3 priority rate rooms with unique rates (excluding accessible rooms)
		var top3Priority = [];
		var remainingPriority = [];
		var seenRates = {};
		for (var j = 0; j < priorityRooms.length; j++) {
			var rate = _getRate(priorityRooms[j]);
			var isAccessible = priorityRooms[j].roomName && priorityRooms[j].roomName.toLowerCase().indexOf('accessible') !== -1;
			if (top3Priority.length < 3 && !seenRates[rate] && !isAccessible) {
				top3Priority.push(priorityRooms[j]);
				seenRates[rate] = true;
			} else {
				remainingPriority.push(priorityRooms[j]);
			}
		}

		// Combine remaining priority rate rooms with non-priority rooms and sort them
		var remainingRooms = remainingPriority.concat(otherRooms);
		remainingRooms.sort(compareRecommended);

		// Return top 3 priority rate rooms followed by the rest
		return top3Priority.concat(remainingRooms);
	}

	function _getSortedRooms(rooms) {
		if (_currentSortMethod === 'lowestPrice') {
			return _sortByLowestPrice(rooms);
		}
		return _sortByRecommended(rooms);
	}

	function _handleSortChange(sortMethod) {
		_currentSortMethod = sortMethod;
		_sortWasChanged = true;
		compass.GA.trackEvent('EPS', 'sort_changed', sortMethod);
		me.trigger('AffiliateAvailableRoomListWidget.sortChanged', { sortMethod: sortMethod });
		_rerenderRoomList();
	}

	function _rerenderRoomList() {
		var roomListContainer = me.find('.roomList');
		if (roomListContainer.length) {
			roomListContainer.empty();
			roomListContainer.append(_renderRoomItems());
		}
		var filterBar = me.find('.filterBar');
		if (filterBar.length) {
			filterBar.replaceWith(_renderFilterBar());
		}
		var tagsContainer = me.find('.filterTags');
		if (tagsContainer.length) {
			tagsContainer.replaceWith(_renderFilterTags());
		}
	}

	function _getTop3PriorityUids(rooms) {
		var priorityRooms = [];
		for (var i = 0; i < rooms.length; i++) {
			if (_isPriorityRate(rooms[i])) {
				priorityRooms.push(rooms[i]);
			}
		}

		priorityRooms.sort(function(a, b) {
			var rateDiff = _getRate(a) - _getRate(b);
			if (rateDiff !== 0) return rateDiff;

			var bedCountA = _getBedCount(a);
			var bedCountB = _getBedCount(b);
			if (bedCountA !== bedCountB) return 0;

			var aHasKing = _hasKingBed(a);
			var bHasKing = _hasKingBed(b);
			if (aHasKing && !bHasKing) return -1;
			if (bHasKing && !aHasKing) return 1;

			return 0;
		});

		var top3 = {};
		var seenRates = {};
		for (var j = 0; j < priorityRooms.length && Object.keys(top3).length < 3; j++) {
			var rate = _getRate(priorityRooms[j]);
			var isAccessible = priorityRooms[j].roomName && priorityRooms[j].roomName.toLowerCase().indexOf('accessible') !== -1;
			if (!seenRates[rate] && !isAccessible) {
				top3[priorityRooms[j].sort_uid] = true;
				seenRates[rate] = true;
			}
		}
		return top3;
	}

	function _renderRoomItems() {
		var currencyCode = _settings.meetingInfo.currencyCode;
		var cf = compass.util.currencyFormatter(currencyCode, { showDecimals : 0, returnAsObject: true });
		var rooms_list = _settings.epsAvail.rooms;
		var sorted_rooms = _getSortedRooms(rooms_list);
		var filtered_rooms = _applyFilters(sorted_rooms);
		var top3PriorityUids = _getTop3PriorityUids(rooms_list);

		if (filtered_rooms.length === 0) {
			return d.div({ className: 'noFilterResults' },
				d.p('No rooms match your current filters. Try adjusting or ',
					d.a({ className: 'clearAllFiltersLink' }, 'clearing all filters').activate(function() {
						_activeFilters = { bedType: [], cancellation: [], payment: [], promotions: [] };
						compass.GA.trackEvent('EPS', 'filters_cleared', '');
						_rerenderRoomList();
					}),
					'.'
				)
			);
		}

		return _.map(filtered_rooms, function(room, roomIndex) {
			room.rooms = _settings.roomsCount;
			room.occupants = _settings.searchCriteria.occupancy;
			room.hotel_name = _settings.epsAvail.hotelName;
			room.affiliate = 'EAN';
			room.name = room.roomName;
			room.GDSInfo = {countryCode: _settings.epsAvail.countryCode};
			room.deposit_required = room.deposits !== undefined;

			var isTopPick = _currentSortMethod === 'recommended' && top3PriorityUids[room.sort_uid];

			var bedNames = '';
			var bedNameArray = [];
			var selectButton = d.button({ className : 'selectRoom secondaryButton disabled', 'disabled': 'true', tabindex : 0 }, 'Select').activate(_handleSelectButtonClosure(room, isTopPick));

			//Find all available rate details
			var rateRefundable, rateCancelPenalties, rateNonrefundableDateRanges, ratePayDetails, ratePromoDescription, rateAmenities;
			if (room.merchant_of_record === 'property') {
				// for merchant of record property and non-refundable
				if (room.refundable === false) {
					if (room.cancel_penalties !== undefined) {
						rateRefundable = d.li('Cancel penalties non-refundable');
					} else {
						if (room.deposit_required === true) {
							rateRefundable = d.li('Deposits non-refundable');
						} else if (room.deposit_required === false) {
							rateRefundable = d.li('Non-refundable');
						}
					}
				}
			} else if (room.merchant_of_record === 'expedia') {
				// for merchant if property expedia
				if (room.refundable === false) {
					rateRefundable = d.li("Non-refundable");
				}
			}
			if (room.cancel_penalties !== undefined) {
				var earliestDate = new Date(room.cancel_penalties[0].start);
				for(var cancelIndex=0; cancelIndex < room.cancel_penalties.length; cancelIndex++) {
					var cancelObject = room.cancel_penalties[cancelIndex];
					var indexedCancelDate = new Date(cancelObject.start);
					if (indexedCancelDate < earliestDate) {
						earliestDate = indexedCancelDate;
					}
				}
				var cancelDate = (earliestDate).toDateString().split(" ");
				rateCancelPenalties = d.li("Free cancellation until " + cancelDate[1] + " " + cancelDate[2]);
			}
			if (room.nonrefundable_date_ranges !== undefined) {
				rateNonrefundableDateRanges = [];
				for(var rangeIndex = 0; rangeIndex < room.nonrefundable_date_ranges.length; rangeIndex++) {
					var rangeObject = room.nonrefundable_date_ranges[rangeIndex];
					var startDate = new Date(rangeObject.start).toDateString().split(" ");
					var endDate = new Date(rangeObject.end).toDateString().split(" ");
					rateNonrefundableDateRanges.push(d.li(
						'Nights from ' + startDate[1] + " " + parseInt(startDate[2]) + " to " + endDate[1] + " " + parseInt(endDate[2]) + " are not refundable"
					));
				}
			}
			if (room.merchant_of_record === 'expedia' || (room.merchant_of_record === 'property' && room.refundable === false)) {
				ratePayDetails = d.li("Pay when booking");
			} else if (room.merchant_of_record === 'property' && room.refundable === true) {
				if (room.deposit_required === false) {
					ratePayDetails = d.li("Pay at time of stay");
				} else if (room.deposit_required === true) {
					ratePayDetails = d.li("Pay with deposit");
				}
			}
			if (room.promotions && room.promotions.deal) {
				if (room.promotions.deal.description !== undefined) {
					ratePromoDescription = d.li(room.promotions.deal.description);
				}
			}
			if (room.amenities !== undefined) {
				rateAmenities = [];
				for(var rateAmenity in room.amenities) {
					rateAmenities.push( d.li( room.amenities[rateAmenity].name) );
				}
			}
			var rateDetails = d.ul(
				rateRefundable,
				rateCancelPenalties,
				rateNonrefundableDateRanges,
				ratePayDetails,
				ratePromoDescription,
				rateAmenities
			);
			var bed_group_ids = Object.keys( room.bed_groups );
			if( bed_group_ids.length > 1) {
				bedNameArray[0] = d.option({value: 'none'}, "Select preferred bed type (not guaranteed)").attr('style', 'display:none');
				for(var index=0; index < bed_group_ids.length; index++){
					var bed = room.bed_groups[ bed_group_ids[ index ] ];
					if (bed.configuration !== undefined) {
						var name = bed.configuration[0].bedType;
						bedNameArray.push( d.option({value: bed.links.price_check.href}, name) );
					}
				}

				if (bedNameArray.length > 1) {
					bedNames = d.select({
						className : 'roomRequestSelect',
						onchange: function (_selected) {
							room.epsPriceCheckLink = _selected.currentTarget.value;
							if(room.epsPriceCheckLink !== 'none') {
								selectButton.removeClass('disabled').removeAttr('disabled', 'false');
							} else {
								selectButton.addClass('disabled').attr('disabled', 'true');
							}
						}
					}, bedNameArray );
				}
			} else if ( bed_group_ids.length === 1) {
				selectButton.removeClass('disabled').removeAttr('disabled', 'false');
				room.epsPriceCheckLink = room.bed_groups[ bed_group_ids[0] ].links.price_check.href;

				var single_bed_group = room.bed_groups[ bed_group_ids[0] ];
				var bedName = '';
				if (single_bed_group.configuration !== undefined) {
					for(var configIdx=0; configIdx < single_bed_group.configuration.length; configIdx++){
						var bedConfig = single_bed_group.configuration[ configIdx ];
						if (configIdx>0){
							bedName += " and ";
						}
						bedName += bedConfig.bedType;
					}
					bedNames = d.div({ className : 'bedName' }, bedName);
				}
			} else { //This is already default behavior, but we'll add the else anyways for clarity
				bedNames = ''; //This means bedGroups is missing configs
			}

			var topPickBadge = isTopPick ? d.div({ className: 'topPickBadge' },
				d.i({ className: 'fa-solid fa-tag' }),
				' Best Value'
			) : '';

			var roomClass = 'availableRoom' + (isTopPick ? ' topPickRoom' : '');

			return d.div({ className: roomClass },
				d.div({ className : 'avgRate' },
					d.span({className: 'currencySymbol'}, cf(room.avgRate).symbol),
					Math.ceil(room.avgRate + room.fees),
					d.span({ className : 'disclaimerMarker' }, '*'),
					topPickBadge
				),
				d.div({ className : 'detailContainer' },
					d.div({ className : 'roomDetails' },
						d.div({ className : 'roomName' }, room.roomName),
						bedNames,
						d.a({ className : 'infoLink' }, 'View room info &raquo;').activate(_handleViewRoomInfoClick(room))
					),
					d.div({ className : 'rateDetails' },
						rateDetails
					)
				),
				d.div({ className : 'selectRoomColumn'},
					selectButton
				)
			);
		});
	}

	function _wouldSortOrderDiffer(rooms) {
		if (!rooms || rooms.length <= 1) {
			return false;
		}
		var recommendedOrder = _sortByRecommended(rooms);
		var lowestPriceOrder = _sortByLowestPrice(rooms);

		for (var i = 0; i < rooms.length; i++) {
			if (recommendedOrder[i].sort_uid !== lowestPriceOrder[i].sort_uid) {
				return true;
			}
		}
		return false;
	}

	function _renderSortDropdown() {
		var rooms_list = _settings.epsAvail && _settings.epsAvail.rooms;

		// Don't show if no rooms loaded or if sort order wouldn't differ
		if (!rooms_list || rooms_list.length === 0 || !_wouldSortOrderDiffer(rooms_list)) {
			return '';
		}

		var sortOptions = [
			{ label: 'Recommended', value: 'recommended' },
			{ label: 'Lowest Price', value: 'lowestPrice' }
		];

		var sortTooltip = d.div({ className: 'sortTooltip' },
			'"Recommended" highlights smart choices. Switch to "Lowest Price" anytime.'
		);

		var sortInfoIcon = d.span({ className: 'sortInfoIcon', tabindex: 0 },
			d.i({ className: 'fa-solid fa-circle-info' })
		);

		sortInfoIcon.on('mouseenter focus', function() {
			sortTooltip.addClass('visible');
		});

		sortInfoIcon.on('mouseleave blur', function() {
			sortTooltip.removeClass('visible');
		});

		var sortSublabel = d.div({ className: 'sortSublabel' }, 'Based on availability and value');

		var sortDropdown = d.dataSelect({
			data: sortOptions,
			initialSelection: 0,
			className: 'sortDropdown',
			change: function(selected) {
				_handleSortChange(selected.value);
				if (selected.value === 'recommended') {
					sortSublabel.removeClass('hidden');
				} else {
					sortSublabel.addClass('hidden');
				}
			},
			labelMapper: function(data) { return data.label; },
			choiceMapper: function(data) { return data.label; },
			idGenerator: compass.generateId
		});

		return d.div({ className: 'sortControlWrapper' },
			d.div({ className: 'sortLabelRow' },
				d.span({ className: 'sortLabel' }, 'Sort:'),
				sortInfoIcon,
				sortTooltip,
				sortDropdown
			),
			sortSublabel
		);
	}

	var _filterConfig = [
		{ key: 'bedType', label: 'Bed Type', icon: 'fa-bed' },
		{ key: 'cancellation', label: 'Cancellation', icon: 'fa-rotate-left' },
		{ key: 'payment', label: 'Payment', icon: 'fa-credit-card' },
		{ key: 'promotions', label: 'Promotions', icon: 'fa-gift' }
	];

	function _renderFilterBar() {
		var rooms_list = _settings.epsAvail && _settings.epsAvail.rooms;
		if (!rooms_list || rooms_list.length === 0) return '';

		var availableOptions = _discoverFilterOptions(rooms_list);
		var dropdowns = [];

		for (var f = 0; f < _filterConfig.length; f++) {
			var config = _filterConfig[f];
			var opts = availableOptions[config.key];
			if (!opts || opts.length < 2) continue;
			dropdowns.push(_renderFilterDropdown(config, opts));
		}

		if (dropdowns.length === 0) return '';

		return d.div({ className: 'filterBar' }, dropdowns);
	}

	function _createFilterOption(config, val, panel) {
		var isChecked = _activeFilters[config.key].indexOf(val) !== -1;
		var checkbox = d.input({
			type: 'checkbox',
			'data-category': config.key,
			'data-value': val
		});
		if (isChecked) checkbox.prop('checked', true);

		var label = d.label({ className: 'filterOption' },
			checkbox,
			d.span(val)
		);

		checkbox.on('change', function() {
			var idx = _activeFilters[config.key].indexOf(val);
			if (this.checked) {
				if (idx === -1) _activeFilters[config.key].push(val);
				compass.GA.trackEvent('EPS', 'filter_applied', config.key + ':' + val);
			} else {
				if (idx !== -1) _activeFilters[config.key].splice(idx, 1);
				compass.GA.trackEvent('EPS', 'filter_removed', config.key + ':' + val);
			}
			_rerenderRoomList();
		});

		panel.append(label);
	}

	function _renderFilterDropdown(config, options) {
		var panel = d.div({ className: 'filterDropdownPanel' });

		for (var i = 0; i < options.length; i++) {
			_createFilterOption(config, options[i], panel);
		}

		var activeCount = _activeFilters[config.key].length;
		var countBadge = activeCount > 0 ? d.span({ className: 'filterCount' }, activeCount) : '';

		var trigger = d.div({ className: 'filterDropdownTrigger' + (activeCount > 0 ? ' active' : '') },
			d.i({ className: 'fa-solid ' + config.icon }),
			d.span({ className: 'filterDropdownLabel' }, config.label),
			countBadge,
			d.i({ className: 'fa-solid fa-chevron-down filterChevron' })
		);

		var bodyNs = 'click.filterDropdown_' + config.key;
		trigger.on('click', function(e) {
			e.stopPropagation();
			var wasOpen = panel.is(':visible');
			// Close all other open panels
			me.find('.filterDropdownPanel:visible').hide();
			me.find('.filterDropdownTrigger.open').removeClass('open');

			if (!wasOpen) {
				panel.show();
				trigger.addClass('open');
				$j('body').off(bodyNs).one(bodyNs, function() {
					panel.hide();
					trigger.removeClass('open');
				});
			}
		});

		panel.on('click', function(e) {
			e.stopPropagation();
		});

		return d.div({ className: 'filterDropdown' }, trigger, panel);
	}

	function _createFilterTag(cat, val, label, icon) {
		var removeBtn = d.span({ className: 'filterTagRemove' }, '\u00D7');
		removeBtn.on('click', function() {
			var idx = _activeFilters[cat].indexOf(val);
			if (idx !== -1) _activeFilters[cat].splice(idx, 1);
			compass.GA.trackEvent('EPS', 'filter_removed', cat + ':' + val);
			_rerenderRoomList();
		});

		return d.span({ className: 'filterTag' },
			d.i({ className: 'fa-solid ' + icon }),
			d.span(label + ': ' + val),
			removeBtn
		);
	}

	function _renderFilterTags() {
		var tags = [];
		var hasActive = false;

		for (var f = 0; f < _filterConfig.length; f++) {
			var config = _filterConfig[f];
			var values = _activeFilters[config.key];
			for (var v = 0; v < values.length; v++) {
				hasActive = true;
				tags.push(_createFilterTag(config.key, values[v], config.label, config.icon));
			}
		}

		if (hasActive) {
			var clearAll = d.a({ className: 'clearAllFilters' }, 'Clear all filters');
			clearAll.on('click', function() {
				_activeFilters = { bedType: [], cancellation: [], payment: [], promotions: [] };
				compass.GA.trackEvent('EPS', 'filters_cleared', '');
				_rerenderRoomList();
			});
			tags.push(clearAll);
		}

		return d.div({ className: 'filterTags' }, tags);
	}

	this.render = function(widgetElem) {
		var currencyCode = _settings.meetingInfo.currencyCode;

		var roomsCountLabel = _settings.roomsCount + ' room' + (_settings.roomsCount != 1 ? 's' : '');
		var occupancyLabel = _settings.occupancyLabels[_settings.searchCriteria.occupancy];
		var arriveLabel = _formatShortDate('Check-in: ', _settings.searchCriteria.arrive);
		var departLabel = _formatShortDate('Check-out: ', _settings.searchCriteria.depart);

		var rooms_list = _settings.epsAvail.rooms;
		var has_fee_disclaimer = rooms_list.length > 0 && rooms_list[0].fees > 0;

		widgetElem.append(d.div({ className : 'roomListContainer' },
			d.div({ className : 'backLink' },
				d.a({ href : '#' }, '&laquo; Back to search').activate(function() {
					me.trigger('AffiliateAvailableRoomListWidget.back');
					return false;
				})
			),
			d.div({ className : 'searchHeader' },
				d.div({ className : 'searchHeaderItem searchTitle' }, 'Current search:'),
				d.div({ className : 'searchHeaderItem resultsCount' }, roomsCountLabel),
				d.div({ className : 'searchHeaderItem occupancy' }, occupancyLabel),
				d.div({ className : 'searchHeaderItem arrive' }, arriveLabel),
				d.div({ className : 'searchHeaderItem depart' }, departLabel)
			),
			d.div({ className: 'disclaimerSortRow' },
				d.div({ className : 'disclaimer' },
					'* All rates ' + currencyCode + ' | Average nightly rate per room' + (has_fee_disclaimer ? ' | Rate includes mandatory hotel fee' : '')
				),
				_renderSortDropdown()
			),
			_renderFilterBar(),
			_renderFilterTags(),
			d.div({ className : 'roomList' },
				_renderRoomItems()
			)
		));
	};

}, {
	WUID : 'defaultAffiliateAvailableRoomListWidgetWUID',
	widgetName : 'AffiliateAvailableRoomListWidget',
	searchCriteria : { },
	occupancyLabels : [
		'No Occupancy',
		'Single Occupancy',
		'Double Occupancy',
		'Triple Occupancy',
		'Quad Occupancy'
	],
	roomsCount : 1,
	meetingInfo : {}
});
